import clsx from "clsx";
import { useIntl } from "react-intl";

import { Button } from "@/components/Button/Button";
import { IconLuggagePurple, IconLuggageSelected } from "@/components/Icons";
import type { GetFlightAvailabilityTokenOptionsPrice } from "@/types/codegen";
import { formatCurrency } from "@/utils/currency";

type Props = {
  label: string;
  price: GetFlightAvailabilityTokenOptionsPrice;
  selected: boolean;
  onClick: () => void;
};

export const BaggageOptionCard = ({
  label,
  price,
  selected,
  onClick,
}: Props) => {
  const intl = useIntl();
  const BaggageIcon = selected ? IconLuggageSelected : IconLuggagePurple;

  return (
    <div
      className={clsx(
        "flex items-start justify-between gap-3 rounded-2xl border bg-white p-3",
        {
          "border-stroke-neutral-soft": !selected,
          "border-core-accent-500": selected,
        },
      )}
    >
      <div className="flex gap-1">
        <BaggageIcon className="size-6 shrink-0" />
        <div className="flex flex-col gap-1 text-text-primary">
          <div className="font-medium">{label}</div>
          {price.amount !== null ? (
            <div className="font-semibold">
              {formatCurrency(price.amount, price.currency || undefined)}
            </div>
          ) : null}
        </div>
      </div>
      <div className="min-w-[69px]">
        <Button
          fullWidth
          variant="outlined"
          size="small"
          color={selected ? "error" : "primary"}
          onClick={onClick}
        >
          {selected
            ? intl.formatMessage({ id: "remove", defaultMessage: "Remove" })
            : intl.formatMessage({ id: "add", defaultMessage: "Add" })}
        </Button>
      </div>
    </div>
  );
};
